import React from 'react';
import { Box } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useTranslation } from 'react-i18next';
import {
  errorTextFieldSx,
  getDateAdapterLocale,
  getDatePickerLocaleText,
  popperSx,
  textFieldSx,
} from './datePickerStyles';
import { DATE_PICKER_VIEWS, useStableDatePickerPopup } from './useStableDatePickerPopup';

const SalovareDatePicker = ({
  value,
  onChange,
  error = false,
  helperText,
  format = 'dd/MM/yyyy',
  placeholder = 'dd/mm/yyyy',
  openTo = 'day',
  disableFuture = false,
  disablePast = false,
  minDate,
  maxDate,
  hideTextField = false,
  slotProps,
  ...datePickerProps
}) => {
  const { t, i18n } = useTranslation();
  const adapterLocale = getDateAdapterLocale(i18n.language);
  const popup = useStableDatePickerPopup({
    value,
    onChange,
    open: datePickerProps.open,
    onOpen: datePickerProps.onOpen,
    onClose: datePickerProps.onClose,
    openTo,
  });

  const picker = (
      <DatePicker
        {...datePickerProps}
        value={popup.value}
        onChange={popup.onChange}
        format={format}
        views={DATE_PICKER_VIEWS}
        openTo={openTo}
        open={popup.open}
        onOpen={popup.onOpen}
        onClose={popup.onClose}
        onViewChange={popup.onViewChange}
        disableFuture={disableFuture}
        disablePast={disablePast}
        minDate={minDate}
        maxDate={maxDate}
        slotProps={{
          ...slotProps,
          textField: {
            placeholder,
            fullWidth: !hideTextField,
            ...slotProps?.textField,
            error,
            helperText: hideTextField ? undefined : helperText,
            sx: {
              ...(error ? errorTextFieldSx : textFieldSx),
              ...(hideTextField ? { display: 'none' } : {}),
              ...slotProps?.textField?.sx,
            },
          },
          popper: {
            sx: popperSx,
            disableScrollLock: true,
            ...slotProps?.popper,
          },
        }}
      />
  );

  return (
    <LocalizationProvider
      adapterLocale={adapterLocale}
      dateAdapter={AdapterDateFns}
      localeText={getDatePickerLocaleText(t)}
    >
      {hideTextField ? (
        <Box
          aria-hidden
          sx={{
            position: 'absolute',
            width: 0,
            height: 0,
            overflow: 'hidden',
            clip: 'rect(0 0 0 0)',
          }}
        >
          {picker}
        </Box>
      ) : picker}
    </LocalizationProvider>
  );
};

export default SalovareDatePicker;
